import React, { useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { Collapse, Button } from "@mui/material";
import steve from "../../../assets/team/steve.jpg";
import adeni from "../../../assets/team/adeni.jpg";
import nanna from "../../../assets/team/nnana.jpg";
import babs from "../../../assets/team/babs.jpg";
import bukola from "../../../assets/team/bukola.jpg";
import olumide from "../../../assets/team/olumide.jpg";

const data = [
  {
    imgpath: steve,
    name: "Steve Okeleji",
    title: "President",
    description:
      "Steve Okeleji is a visionary leader and advocate for the transformation of blue food systems, with a special focus on sustainability, innovation, and community empowerment. Through his remarkable work in the aquaculture and fisheries sectors, Steve...",
    detail1:
      "Steve Okeleji, born to a veterinarian father with a large commercial farm, gained early agricultural experience and began his journey in aquaculture during his second year in 2006 while studying Aquaculture and Fisheries Management at the Federal University of Agriculture in Ogun State, Nigeria, he founded Fish Shoal Nigeria. Later, as a scholar at the Netherlands Business School, Steve was recognized as the African Champion for Agricultural Development in 2021 by African Impact in Accra, Ghana, and currently serves as a member of the United Nations Private Sector Advisory Group.",
    detail2:
      "Steve Okeleji is a visionary leader dedicated to transforming blue food systems with a strong focus on sustainability, innovation, and community empowerment. Through his extensive work in aquaculture and fisheries, he has played a pivotal role in promoting sustainable management of aquatic resources while addressing food security, economic development, and environmental conservation.",
    detail3:
      "A defining achievement in Steve's career is his commitment to empowering women in the blue economy. Recognizing their crucial roles in fisheries and aquaculture—from fish farming to processing and marketing—Steve has implemented programs that provide women with training, financial resources, and access to technology. These efforts have significantly improved livelihoods in coastal and rural communities, positioning women as key contributors to local economies. By integrating women into the blue food value chain, Steve advances gender equality and fosters resilient, inclusive food systems.",
    detail4:
      "Steve’s work is also characterized by his innovative approach to aquaculture, where he has developed sustainable practices that minimize environmental impact while boosting productivity. He has pioneered eco-friendly technologies like integrated multi-trophic aquaculture (IMTA) systems, which reduce waste and enhance biodiversity in aquatic farming. His sustainable aquaculture initiatives set a high standard for balancing environmental responsibility with economic growth. Through partnerships with governments, NGOs, and local communities, Steve Okeleji continues to shape policies and educate others on the importance of healthy oceans and waterways. His leadership in advancing sustainable blue food systems has earned him recognition as a global champion for aquaculture, climate action, and food security.",
  },
  {
    imgpath: nanna,
    name: "Nnana Sunday",
    title: "Country Manager",
    description:
      "Nnana serves as the project manager for the organization. He is a management consultant and a certified Business Development Service Provider with years of experience working with SMEs and international development organizations to develop and implement strategies...",
    detail1:
      "Nnana serves as the project manager for the organization. He is a management consultant and a certified Business Development Service Provider with years of experience working with SMEs and international development organizations to develop and implement strategies that improve performance and make an impact in the lives of underserved populations.",
    detail2:
      "He is passionate about supporting start-ups and early-stage businesses to achieve growth potential and make an impact on the African continent. He is a member of the United Nations Volunteer Network. His work experience spans Agriculture, climate change, Health, and Economic development sectors.",
    detail3:
      "He holds a bachelor's degree in Banking and Finance and an MBA from the University of the People. In addition, he is a member of the Project Management Professional Network.",
    detail4: "",
  },
  {
    imgpath: babs,
    name: "Babatunde Adeleke",
    title: "Executive Director, Coastal Resources",
    description:
      "Babatunde Adeleke is a sustainable and conservation finance specialist with more than sixteen years of interdisciplinary experience spanning marine science, aquaculture development, impact investing, and nature-positive finance across Africa and emerging markets.",
    detail1:
      "Babatunde Adeleke is a sustainable and conservation finance specialist with more than sixteen years of interdisciplinary experience spanning marine science, aquaculture development, impact investing, and nature-positive finance across Africa and emerging markets. He combines a strong scientific foundation with advanced financial expertise to design, structure, and operationalize innovative financing solutions that support biodiversity conservation, climate resilience, and inclusive economic development.",
    detail2:
      "He holds a PhD in Marine Biology and Sustainable Aquaculture Development and a Master of Advanced Studies in Sustainable Finance and Development from the Geneva Graduate Institute. His academic background enables him to bridge ecological science with financial structuring, policy alignment, and investment design, particularly in complex conservation and blue economy contexts.",
    detail3:
      "Dr. Adeleke has led and contributed to multiple high-profile initiatives involving conservation trust funds, blended-finance mechanisms, payment for ecosystem services, biodiversity and carbon finance, and sustainable value-chain development. His work includes advisory roles on protected area financing, eco-industrial park financing strategies, blue economy investment models, and donor-funded resource mobilization strategies aligned with international standards and climate finance frameworks.",
    detail4:
      "Dr. Adeleke is recognized for his ability to translate complex financial concepts into practical, implementable solutions for diverse stakeholders. His professional focus is on mobilizing blended capital, strengthening institutional sustainability, and scaling nature-based and climate-resilient investments that deliver measurable environmental and social impact. He is a member of the Management Team and Advisory Board.",
  },
  {
    imgpath: bukola,
    name: "Oluwabukola Echue",
    title: "Head of Communication & Partnership",
    description:
      "Oluwabukola Echue is versatile professional with over 7 years of experience in program management, project coordination, and stakeholder engagement. She has a proven track record of delivering exceptional results, driving projects forward, and fostering strong relationships.",
    detail1:
      "Oluwabukola Echue is versatile professional with over 7 years of experience in program management, project coordination, and stakeholder engagement. She has a proven track record of delivering exceptional results, driving projects forward, and fostering strong relationships. She is with skilled in behavioural economics analysis, monitoring and evaluation, and content development. ",
    detail2:
      "Oluwabukola supports program implementation and coordination, collaborates with stakeholders and partners, tracks program progress and reports insights, that contributes to content development and dissemination. She is adept at managing priorities, analysing data, and driving process improvements, with a strong commitment to achieving program goals and making a meaningful impact.",
    detail3:
      "Her diverse experience spans across media, health, and human capacity building sectors, bringing a unique interdisciplinary approach to her work. As a passionate advocate for human capacity and development, she has been involved in implementing programs for over 000 youths across Nigeria, and has been an active member of The Socacemp Initiative since 2016.",
    detail4:
      "Oluwabukola is a skilled communicator with excellent interpersonal and problem solving skills, proven to work effectively in fast-paced environments and drive result-oriented solutions.",
  },
  {
    imgpath: olumide,
    name: "Olumide Okutoro",
    title: "Head of Finance",
    description:
      "Olumide Okutoro is a qualified finance professional with more than 15 years of experience in financial analysis, accounting, and advisory across both public and private sector organisations. He specialises in interpreting financial and operational data to produce actionable insights...",
    detail1:
      "Olumide Okutoro is a qualified finance professional with more than 15 years of experience in financial analysis, accounting, and advisory across both public and private sector organisations. He specialises in interpreting financial and operational data to produce actionable insights that support senior management decision-making. His core expertise includes financial modelling, management accounting, budgeting and forecasting, performance analysis, and financial reporting under IFRS. Olumide is also recognised for his ability to translate complex financial data into clear management information and KPI reporting that improves organisational understanding of financial performance. ",
    detail2:
      "Throughout his career, Olumide has demonstrated strong capability in strengthening financial systems and governance structures. While working as a consultant with KMH Chartered Accountants, he led several transformation initiatives within municipalities and private sector organisations. His work included evaluating financial processes, implementing improved reporting frameworks, and embedding internal control systems that enhanced operational efficiency and transparency. Notably, he played a key role in turning a previously qualified municipal audit opinion into an unqualified audit opinion by implementing stronger financial controls and reporting mechanisms.",
    detail3:
      "Olumide’s technical strengths extend across financial reporting, variance and ratio analysis, working capital management, project accounting, and cashflow forecasting. He also brings strong commercial awareness and business partnering capabilities, enabling him to collaborate effectively with operational teams and senior stakeholders. In multiple engagements, he has improved billing systems, identified financial discrepancies, and implemented new accounting processes that enhanced accuracy and increased revenue collection—achieving measurable outcomes such as a 27% improvement in revenue and cash collection for a municipal client. ",
    detail4:
      "Currently serving as Finance Manager at Blue Echo Foundation, Olumide oversees financial analysis, budgeting, and forecasting processes to ensure sound financial planning and project viability. His background includes progressive roles from audit training and consultancy to senior financial advisory, supported by strong professional qualifications including ICAN Chartered Accountant, CIMA Chartered Management Accountant, and advanced financial modelling certification. This combination of technical expertise, advisory experience, and strategic financial insight positions him as a finance leader capable of driving financial performance and organisational improvement.",
  },
  {
    imgpath: adeni,
    name: "Adeni Olugbenga",
    title: "Head of Admin & Operations",
    description:
      "Adeni Olugbenga is a highly accomplished professional banker with over twenty years of banking experience. He has held functional roles in banking operations, banking marketing, and branch audit with remarkable achievements. Olugbenga holds a Bachelor of Science in Banking and Finance from Olabisi Onabanjo University...",
    detail1:
      "Adeni Olugbenga is a highly accomplished professional banker with over twenty years of banking experience. He has held functional roles in banking operations, banking marketing, and branch audit with remarkable achievements. Olugbenga holds a Bachelor of Science in Banking and Finance from Olabisi Onabanjo University, Ago-Iwoye, Ogun State, and he is also an Associate of the Chartered Institute of Bankers of Nigeria. Currently, Olugbenga serves as the Head of Admin & Operations, Blue-Echo Foundation, where he continues to lead efforts in promoting sustainable aquaculture practices in emerging economies. ",
    detail2: "",
    detail3: "",
    detail4: "",
  },
];

const Management = () => {
  // Track open/close state for each profile
  const [expanded, setExpanded] = useState(Array(data.length).fill(false));

  const handleExpandClick = (index) => {
    const newExpanded = [...expanded];
    newExpanded[index] = !newExpanded[index];
    setExpanded(newExpanded);
  };

  return (
    <Box margin={{ xs: "5% 0%", sm: "0% 0% 10% 0%" }}>
      <Grid container spacing={1}>
        {data.map((list, index) => {
          const {
            imgpath,
            name,
            title,
            description,
            detail1,
            detail2,
            detail3,
            detail4,
          } = list;
          return (
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              marginTop={{ xs: "5%", sm: "3%" }}
              key={index}
            >
              <Card sx={{ maxWidth: 360, height: "100%" }}>
                <CardMedia
                  component="img"
                  height="340"
                  image={imgpath}
                  sx={{ objectFit: "cover" }}
                  alt={name}
                />
                <CardContent>
                  <Typography
                    gutterBottom
                    variant="h5"
                    color={"#317ABE"}
                    component="div"
                    fontWeight={700}
                    paddingBottom={"1%"}
                  >
                    {name}
                  </Typography>
                  <Typography
                    paddingBottom={"2%"}
                    variant="body2"
                    color="#9DCC49"
                    fontWeight={700}
                  >
                    {title}
                  </Typography>
                  {!expanded[index] && (
                    <Typography paddingBottom={"5%"} variant="body1">
                      {description}
                    </Typography>
                  )}

                  {/* Collapse Toggle Button */}
                  <Button
                    onClick={() => handleExpandClick(index)}
                    variant="text"
                    sx={{
                      color: "#317ABE",
                      fontWeight: 700,
                      "&:hover": { color: "#9DCC49" },
                    }}
                  >
                    {expanded[index] ? "Read Less" : "Read More"}
                  </Button>

                  {/* Collapse Detail Section */}
                  <Collapse in={expanded[index]} timeout="auto" unmountOnExit>
                    <Typography variant="body1" paddingTop={"2%"}>
                      {detail1}
                    </Typography>
                    <Typography variant="body1" paddingTop={"3%"}>
                      {detail2}
                    </Typography>
                    <Typography variant="body1" paddingTop={"3%"}>
                      {detail3}
                    </Typography>
                    <Typography variant="body1" paddingTop={"3%"}>
                      {detail4}
                    </Typography>
                  </Collapse>
                </CardContent>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default Management;
